<template>
  <div class="contract-details">
    <div class="title" style="display: flex; align-items: center">
      <!-- <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.go(-1)" /> -->
      <h1 style="margin: 0">合同/合同详情</h1>
      <!-- <a-icon @click="reback" type="left-circle" style="font-size: 20px; margin-left: 10px; margin-top: 6px" /> -->
    </div>
    <uiHeader
      ref="uiHeader"
      :userId="userId"
      :clientWidth="clientWidth"
      :islessorsType="islessorsType"
      :detailsUrl="detailsUrl"
      :contractsDetails="contractsDetails"
      :paymentTypeList="paymentTypeList"
      :investmentTypelist="investmentTypelist"
      :customerTypeList="customerTypeList"
      :achievementList="achievementList"
      @editContract="editContract"
      @getDeleteContractsInfo="getDeleteContractsInfo"
      @getContractFile="getContractFile"
      @getContractExamine="getContractExamine"
      @handleOk="handleOk"
      @checkFile="checkFile"
      @editBtn="editBtn"
      @submitPutStatus="submitPutStatus"
    />

    <div class="commission-achievement">
      <commission
        :userId="userId"
        :alreadyCollection="alreadyCollection"
        :answerCollection="answerCollection"
        :contractsDetails="contractsDetails"
        :commission="commission"
        :blushCollection="blushCollection"
        :commissionList="commissionList"
        @commissionClick="commissionClick"
        @seeCollectionPrice="seeCollectionPrice"
        @commissionDetailClick="commissionDetailClick"
      />
      <schievement
        :contractsDetails="contractsDetails"
        :achievementList="achievementList"
        :achievementTypeList="achievementTypeList"
        :commission="commission"
        :isDistribution="isDistribution"
        @achievementClick="achievementClick"
        @getDistributionFn="getDistributionFn"
        @getDeleteDeleteAchievement="getDeleteDeleteAchievement"
      />
    </div>
    <!-- 添加业绩人弹窗 -->
    <modal-result-people
      :detailsId="detailsId"
      :deptList="deptList"
      :commissionSum="commission.sum"
      :achievementList="achievementList"
      :achievementTypeList="achievementTypeList"
      :contractsDetails="contractsDetails"
      @success="getAchievementList"
      ref="modalResultPeople"
    />
    <!-- 查看附件弹窗 -->
    <modalCheckFile :contractsDetails="contractsDetails" @priviewFile="priviewFile" ref="modalCheckFile" />

    <!-- 添加佣金弹窗 -->
    <modal-commission
      :isdisabled="isdisabled"
      ref="modalCommission"
      :contractId="detailsId"
      :commissionTypeList="commissionTypeList"
      @submit="commissionOnSubmit"
    />

    <!-- 查看明细弹窗 -->
    <modalCollectInfo ref="modalCollectInfo" />

    <!-- 添加收佣明细弹窗 -->
    <modalCollectCommission ref="modalCollectCommission" @onSuccess="commissionSuccess" />

    <!-- 业主-二房东-弹窗 -->
    <modalHouse ref="modalHouse" @onSuccess="modalTenantsSuccess()" />

    <!-- 租客-弹窗 -->
    <modalTenants ref="modalTenants" @onSuccess="modalTenantsSuccess()" />
    <UpFileModal ref="upFileModal" :file="selectFile" />
  </div>
</template>

<script>
import {
  achievementsAllotRecord,
  addCommission,
  commissionRecord,
  commissionRecordDetail,
  contractExamine,
  contractFile,
  contractsInfo,
  deleteAchievement,
  deleteCommission,
  deleteContractsInfo,
  edit_contractDelivery,
  editCommission,
  getAchievements,
  rushCommission,
  updateAccessory
} from '@/api/system/contract';
import { treeselect } from '@/api/system/dept';
import FileUpload from '@/components/FileUpload/index.vue';
import moment from 'moment';
import touristApi from '@/api/system/tourist/tourist';

// 顶部详情
import uiHeader from './components/ui-header.vue';
// 佣金记录
import commission from './components/commission.vue';

// 业绩分配
import schievement from './components/achievement.vue';
// 弹窗
import modalResultPeople from './components/modal/modal-result-people.vue';
import modalCheckFile from './components/modal/modal-check-file.vue';
import modalCommission from './components/modal/modal-commission.vue';
import modalCollectCommission from './components/modal/modal-collect-commission.vue';
import modalTenants from './components/modal/modal-tenants.vue';
import modalHouse from './components/modal/modal-house.vue';
import modalCollectInfo from './components/modal/modal-collect-info.vue';
import UpFileModal from '@/components/modal/FileModal/upFile.vue';

const data = [];

const OSS_BASE_URL = process.env.VUE_APP_OSS_URL;
let loadingStatus = false; // 加载状态
export default {
  name: 'ContractDetails',
  components: {
    FileUpload,
    uiHeader,
    commission,
    schievement,
    modalResultPeople,
    modalCheckFile,
    modalCommission,
    modalCollectCommission,
    modalTenants,
    modalHouse,
    modalCollectInfo,
    UpFileModal
  },
  data() {
    return {
      isdisabled: false,
      paymentTypeList: [],
      // 修改合同的业主-二房东信息-参数
      // is_modal_tourist: false,
      // form_house: {
      //   id: 0,
      //   lessorCardNo: '',
      //   lessorsName: '',
      //   lessorsPhone: ''
      // },
      // 修改合同租客信息-参数
      // is_modal_house: false,
      // form_tourist: {
      //   id: 0, // 合同ID
      //   lesseeBrandName: '',
      //   lesseeCardNo: '',
      //   lesseeName: '',
      //   lesseePhone: ''
      // },
      customerTypeList: [],
      data,
      // commissionDetailedVisible: false, // 佣金明细弹窗
      alreadyCollection: 0, // 已收
      answerCollection: 0, // 应收
      blushCollection: 0, //冲红
      commissionRecordId: '', // 佣金记录id
      investmentTypelist: [],
      // collectionVisible: false,
      // imgUrlpor: require('@/assets/home-imgs/头像.svg'),
      otherUrl: '',
      otherUrlOssid: '',
      visible_modal: false,
      islessorsType: false,
      userId: this.$getters.userInfo.userId,
      clientWidth: null,
      achievementTypeList: [],
      OSS_BASE_URL,
      detailsUrl: '',
      isEditCommission: false,
      isDistribution: false,
      // visible: false, // 添加修改业绩人弹窗
      // commissionVisible: false,
      // enclosureVisible: false, // 合同附件弹窗
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },

      // commissionTitle: '添加佣金',
      // achievementLabelCol: { span: 0 },
      // achievementWrapperCol: { span: 20 },
      moreVisible: false,
      // form: {
      //   contractRole: undefined,
      //   deptId: undefined,
      //   achievementsRatio: '',
      //   deptName: '',
      //   employeeId: '',
      //   employeeName: ''
      // },
      // commissionForm: {
      //   commissionType: undefined,
      //   commissionFee: ''
      // },
      commission: {
        informationPrice: 0,
        house: 0,
        customer: 0,
        sum: 0
      },
      commissionList: [],
      contractsDetails: {},
      deliveryTime: '',
      detailsId: '',
      // rules: {
      //   commissionType: [{ required: true, message: '请选择佣金类型', trigger: 'change' }],
      //   commissionFee: [{ required: true, message: '请输入金额', trigger: 'blur' }]
      // },
      commissionTypeList: [], // 佣金类型列表
      commissionId: '', // 佣金ID
      contractsDetailsId: '', // 获取佣金详情id
      achievementList: [],
      deptList: [],
      // userList: [],
      // isuser: true,

      // 部门树选项
      // deptOptions: [
      //   {
      //     id: 0,
      //     label: '',
      //     children: []
      //   }
      // ],
      // replaceFields: { children: 'children', title: 'label', key: 'id', value: 'id' }
      selectFile: {} // 选择的文件
    };
  },
  methods: {
    // 预览文件
    priviewFile(file) {
      console.log(file, 'file');
      this.selectFile = file;
      this.$refs.upFileModal.open();
    },
    // 添加收佣明细成功
    commissionSuccess() {
      // this.getcommissionMsg()
      this.getContractsInfo(this.detailsId);
    },
    // 交件结佣
    submitPutStatus(values) {
      this.updateType = values.updateType;
      this.deliveryTime = values.time ? moment(values.time).format('YYYY-MM-DD HH:mm:ss') : '';
      this.putContractStatus();
    },
    // 改变合同状态
    putContractStatus() {
      if (loadingStatus) {
        this.$message.success('不能重复提交');
        return;
      }
      loadingStatus = true;
      const params = {
        deliveryTime: this.deliveryTime,
        id: this.detailsId,
        updateType: this.updateType
      };
      edit_contractDelivery(params).then((res) => {
        if (res.code === 200) {
          this.$refs.uiHeader.closeModal();
          this.$message.success('操作成功');
          loadingStatus = false;
          this.getContractsInfo(this.detailsId);
        }
      });
    },

    // float验证
    floatValidate(fieldName) {
      // achievementsRatio
      const val = this.form[fieldName];
      const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/;
      if (!reg.test(val)) {
        if (fieldName === 'achievementsRatio') {
          this.form[fieldName] = '';
        }
      }
    },
    // 编辑按钮
    editBtn(obj, thatOne) {
      console.log(obj);
      if (thatOne === 'house') {
        // this.is_modal_house = true
        // this.form_house.id = obj.id
        // this.form_house.lessorsName = obj.lessorsName
        // this.form_house.lessorsPhone = obj.lessorsPhone
        // this.form_house.lessorCardNo = obj.lessorCardNo

        this.$refs.modalHouse.is_modal_house = true;
        this.$refs.modalHouse.form_house.id = obj.id;
        this.$refs.modalHouse.form_house.lessorsName = obj.lessorsName;
        this.$refs.modalHouse.form_house.lessorsPhone = obj.lessorsPhone;
        this.$refs.modalHouse.form_house.lessorCardNo = obj.lessorCardNo;
      } else {
        // this.is_modal_tourist = true
        // this.form_tourist.id = obj.id
        // this.form_tourist.lesseeBrandName = obj.lesseeBrandName
        // this.form_tourist.lesseeCardNo = obj.lesseeCardNo
        // this.form_tourist.lesseeName = obj.lesseeName
        // this.form_tourist.lesseePhone = obj.lesseePhone

        this.$refs.modalTenants.is_modal_tourist = true;
        this.$refs.modalTenants.form_tourist.id = obj.id;
        this.$refs.modalTenants.form_tourist.lesseeBrandName = obj.lesseeBrandName;
        this.$refs.modalTenants.form_tourist.lesseeCardNo = obj.lesseeCardNo;
        this.$refs.modalTenants.form_tourist.lesseeName = obj.lesseeName;
        this.$refs.modalTenants.form_tourist.lesseePhone = obj.lesseePhone;
      }
    },

    modalTenantsSuccess() {
      this.getContractsInfo(this.detailsId);
    },
    /** 查询部门下拉树结构 */
    getTreeselect() {
      treeselect().then((response) => {
        this.deptOptions = response.data;
        this.$refs.modalResultPeople.deptOptions = response.data;
      });
    },
    // 确认业绩分配
    getDistributionFn() {
      const achievementList = this.achievementList;
      let achievementsRatioTotal = 0;
      let achiRatio = 0;
      for (const achi of achievementList.filter((el) => el.achievementsType == '1')) {
        achiRatio = parseFloat(achi.achievementsRatio);
        achiRatio = achiRatio || 0;
        achievementsRatioTotal += achiRatio;
      }
      if (achievementsRatioTotal > 100) {
        this.$message.error('业绩分配总和不可超过100%！！！');
        // return
      }
      this.isDistribution = !this.isDistribution;
      if (!this.isDistribution) {
        getAchievements({ contractId: this.detailsId }).then((res) => {
          if (res.code === 200) {
            this.$message.success('确认业绩分配成功');
            this.getAchievementList();
          }
        });
      }
    },
    // 佣金明细弹窗
    commissionDetailClick(item) {
      // this.commissionDetailedVisible = true
      // this.commissionRecordId = item.id
      this.$refs.modalCollectCommission.commissionDetailedVisible = true;
      this.$refs.modalCollectCommission.commissionRecordId = item.id;
      this.$refs.modalCollectCommission.contractsDetailsId = this.contractsDetailsId;
      this.$refs.commissionDetailedRuleForm.proceedsTime = moment(new Date());
    },

    // 查看明细
    seeCollectionPrice(item) {
      // this.collectionVisible = true
      this.$refs.modalCollectInfo.collectionVisible = true;
      commissionRecordDetail({ commissionRecordId: item.id }).then((res) => {
        if (res.code === 200) {
          this.data = res.data;
          let commissionType = '';
          if (item.commissionType === '1') {
            commissionType = '房源方';
          } else {
            commissionType = '客源方';
          }
          this.data.forEach((v) => {
            v.commissionType = commissionType;
          });

          this.$refs.modalCollectInfo.setValue(this.data);
        }
      });
    },
    // 补充附件弹窗ok键
    handleOk(obj) {
      const parmars = {
        id: Number(this.$route.query.id),
        otherUrl: obj.otherUrl,
        // 部门树选项
        deptOptions: [
          {
            id: 0,
            label: '',
            children: []
          }
        ],
        replaceFields: { children: 'children', title: 'label', key: 'id', value: 'id' }
      };
      updateAccessory(parmars).then((res) => {
        if (res.code === 200) {
          // this.visible_modal = false
          this.$refs.uiHeader.closeFileModal();
          this.$message.success('添加附件成功');
          // this.otherUrl = ''
          this.getContractsInfo(this.detailsId);
        }
      });
    },
    // uploadOtherUrlOssId (id) {
    //   this.otherUrlOssid = id
    // },
    // uploadOtherUrl (url) {
    //   this.otherUrl = url
    // },
    editCommission() {
      this.isEditCommission = true;
    },

    // handleCancel () {
    //   this.visible = false
    //   this.commissionVisible = false
    // },
    commissionClick(e) {
      // this.commissionVisible = true
      this.$refs.modalCommission.commissionVisible = true;
      this.isdisabled = false;
      if (e === '新增') {
        this.commissionId = '';
        // this.commissionTitle = '添加佣金'
        // this.commissionForm.commissionType = undefined
        // this.commissionForm.commissionFee = ''
        this.$refs.modalCommission.commissionTitle = '添加佣金';
        this.$refs.modalCommission.commissionForm.commissionType = undefined;
        this.$refs.modalCommission.commissionForm.commissionFee = '';
      } else if (e === '冲红') {
        this.$refs.modalCommission.commissionTitle = '冲红';
        this.isdisabled = true;
        this.$refs.modalCommission.commissionForm.commissionType = '6';
        this.$refs.modalCommission.commissionForm.commissionFee = '';
        this.$refs.modalCommission.commissionForm.commissionRemark = '';
      } else {
        this.commissionId = e.id;
        // this.commissionTitle = '编辑佣金'
        // this.commissionForm.commissionType = e.commissionType
        // this.commissionForm.commissionFee = e.commissionFee
        this.$refs.modalCommission.commissionTitle = '编辑佣金';
        this.$refs.modalCommission.commissionForm.commissionType = e.commissionType;
        this.$refs.modalCommission.commissionForm.commissionFee = e.commissionFee;
      }
    },

    achievementClick(e) {
      console.log(e, 'eeeeeeee');
      this.getTreeselect();
      // this.visible = true
      this.$refs.modalResultPeople.visible = true;
      // console.log(this.$refs.modalResultPeople,'99')
      if (e === '新增') {
        // this.commissionTitle = '添加业绩人'
        this.$refs.modalResultPeople.achievementTitle = '添加业绩人';
        this.$refs.modalResultPeople.form = {
          deptId: undefined,
          achievementsRatio: '',
          deptName: '',
          achievementsMoney: '',
          employeeId: undefined,
          employeeName: '',
          contractRole: undefined, // 角色固定值
          resourceType: '',
          performanceType: '1'
        };
        // this.achievementTitle = '添加业绩人'
        // this.form = {
        //   deptId: undefined,
        //   achievementsRatio: '',
        //   deptName: '',
        //   employeeId: undefined,
        //   employeeName: '',
        //   contractRole: undefined // 角色固定值
        // }
      } else {
        this.$refs.modalResultPeople.achievementTitle = '修改业绩人';
        this.$refs.modalResultPeople.form = JSON.parse(JSON.stringify(e));

        // this.commissionTitle = '修改业绩人'
        // this.achievementTitle = '修改业绩人'
        // const achievementsRatio = e.achievementsRatio
        // this.form = e
        // this.form.achievementsRatio = achievementsRatio
        // this.form.contractRole = 1// 角色固定值
      }
    },
    moreHide() {
      this.moreVisible = false;
    },
    // 获取详情
    getContractsInfo(id) {
      contractsInfo(id).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          // 投资类型
          this.getDicts('investment_type').then((response) => {
            if (response.code === 200) {
              this.investmentTypelist = response.data;
            }
          });
          this.getDicts('customer_type').then((response) => {
            this.customerTypeList = response.data;
            // console.log('客户类型', this.customer_type_list)
          });
          this.$nextTick(() => {
            this.contractsDetails = data;
          });
          this.islessorsType = data.contractLessorRelationVoList.some((item) => {
            return item.lessorsType === '1';
          });
          // data.contractLessorRelationVoList
          this.getcommissionMsg(data.id);
          this.contractsDetailsId = data.id;
          if (data.houseInfoVo) {
            if (data.houseInfoVo.houseInfoImgVo.interiorList) {
              this.detailsUrl = data.houseInfoVo.houseInfoImgVo.interiorList[0].fileName;
            }
          }
        }
      });
    },
    //  获取佣金信息
    getcommissionMsg(contractId) {
      commissionRecord({
        contractId
      }).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.getDicts('commission_type').then((response) => {
            this.commissionList = data;
            this.commission.informationPrice = 0; //信息费
            // commissionType 佣金类型
            this.answerCollection = 0; // 应收
            this.alreadyCollection = 0; // 已收金额
            data.forEach((element) => {
              if (element.commissionType === '3' || element.commissionType === '4' || element.commissionType === '5') {
                this.commission.informationPrice += Number(element.commissionFee); // x信息费
              }

              if (element.commissionType === '1') {
                //房源方
                this.commission.house = element.commissionFee;
                this.answerCollection = this.answerCollection + Number(element.commissionFee);
                this.alreadyCollection = this.alreadyCollection + Number(element.realIncome);
              }
              if (element.commissionType === '2') {
                //客源方
                this.commission.customer = element.commissionFee;
                this.answerCollection = this.answerCollection + Number(element.commissionFee);
                this.alreadyCollection = this.alreadyCollection + Number(element.realIncome);
              }

              this.commission.sum = Number(this.commission.house) + Number(this.commission.customer) - Number(this.commission.informationPrice);
              if (element.commissionType === '6') {
                //冲红
                this.commission.sum -= Number(element.commissionFee);
              }
            });
          });
        }
      });
    },
    // 佣金字典类型
    getCommissionType() {
      this.getDicts('commission_type').then((response) => {
        this.commissionTypeList = response.data;
      });
    },
    // 添加编辑佣金确定
    commissionOnSubmit(values) {
      this.$refs.modalCommission.$refs.commissionForm.validate((valid) => {
        if (valid) {
          const { commissionType, commissionFee } = values || this.commissionForm;
          const parmars = {
            commissionType,
            commissionFee,
            contractId: this.detailsId
          };
          if (this.commissionId) {
            // 编辑佣金
            parmars.id = this.commissionId;
            this.getEditCommission(parmars);
          } else {
            if (this.isdisabled) {
              parmars.commissionRemark = values.commissionRemark;
              this.setrushCommission(parmars);
            } else {
              this.getAddCommission(parmars);
            }
          }
          this.getContractsInfo(this.detailsId);
          this.getcommissionMsg(this.contractsDetailsId);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 添加佣金接口
    getAddCommission(parmars) {
      addCommission(parmars).then((res) => {
        if (res.code === 200) {
          this.$message.success('添加成功');
          this.$refs.modalCommission.handleCancel();
          // this.commissionVisible = false
          this.getcommissionMsg(this.contractsDetailsId);
          this.getAchievementList();
        }
      });
    },
    // 冲红
    setrushCommission(parmars) {
      rushCommission(parmars).then((res) => {
        if (res.code === 200) {
          this.$message.success('冲红成功');
          this.$refs.modalCommission.handleCancel();
          this.getAchievementList();
          // this.commissionVisible = false
          this.getcommissionMsg(this.contractsDetailsId);
        }
      });
    },
    // 编辑佣金接口
    getEditCommission(parmars) {
      editCommission(parmars).then((res) => {
        if (res.code === 200) {
          this.$message.success('修改成功');
          this.$refs.modalCommission.handleCancel();
          // this.commissionVisible = false
          this.getcommissionMsg(this.contractsDetailsId);
          this.getAchievementList();
        }
      });
    },
    // 删除佣金
    deleteCommission(item) {
      deleteCommission([item.id]).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.getcommissionMsg(this.contractsDetailsId);
        }
      });
    },
    // num验证
    // numValidate (fieldName) {
    //   const val = fieldName === 'commissionForm.commissionFee' ? this.commissionForm.commissionFee : null
    //   const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/
    //   if (!reg.test(val)) {
    //     this.commissionForm.commissionFee = ''
    //   }
    // },
    // 删除业绩分配
    getDeleteDeleteAchievement(item) {
      deleteAchievement(item.id).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除业绩分配成功');
          this.getAchievementList();
        }
      });
    },
    // 获取业绩分配记录列表
    getAchievementList() {
      const parmars = {
        contractId: this.detailsId
        // pageNum: 1,
        // pageSize: 10
      };
      // const contractId = this.detailsId
      achievementsAllotRecord(parmars).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.achievementList = data.records;
          this.getDicts('related_personne_type').then((response) => {
            if (response.code === 200) {
              response.data.forEach((item) => {
                this.achievementList.forEach((element) => {
                  if (item.dictValue === element.contractRole) {
                    element.contractRole = item.dictValue;
                  }
                });
              });
            }
          });
        }
      });
    },
    // 编辑合同
    editContract() {
      this.$router.push({
        path: '/contract/new',
        query: { id: this.detailsId }
      });
    },
    // 合同归档
    getContractFile() {
      contractFile([this.detailsId]).then((res) => {
        if (res.code === 200) {
          this.$message.success('合同归档成功');
          this.$router.push('/ContractList');
        }
      });
    },
    // 部门下拉列表
    getDeptList() {
      touristApi.getDeptList().then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.deptList = data;
        }
      });
    },

    checkFile() {
      this.$refs.modalCheckFile.enclosureVisible = true;
    },

    // 删除合同信息
    getDeleteContractsInfo() {
      deleteContractsInfo([this.detailsId]).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除合同成功');
          this.$router.push('/ContractList');
        }
      });
    },
    // 返回
    reback() {
      this.$router.go(-1);
    },
    // 获取人员业绩类型字典表
    getContractRoleType() {
      this.getDicts('related_personne_type').then((response) => {
        this.achievementTypeList = response.data;
      });
    },
    getContractExamine() {
      if (loadingStatus) {
        this.$message.success('不能重复提交');
        return;
      }
      loadingStatus = true;
      contractExamine(this.detailsId).then((res) => {
        if (res.code === 200) {
          this.$message.success('提交审核成功');
          loadingStatus = false;
          this.getContractsInfo(this.detailsId);
        }
      });
    }
  },
  created() {
    // 字典列表
    this.getDicts('payment_type2').then((response) => {
      this.paymentTypeList = response.data;
    });
    this.detailsId = this.$route.query.id;
    this.getContractsInfo(this.detailsId);
    this.getAchievementList();
    this.getCommissionType();
    this.getDeptList(); // 部门经纪人
    this.getContractRoleType();
  },
  beforeCreate() {
    if (document.body.clientWidth >= 1900) {
      this.clientWidth = window.document.documentElement.clientWidth;
    } else {
      this.clientWidth = null;
    }
  },

  watch: {
    'form.deptId': {
      handler(newVal, oldVal) {
        if (this.form.deptId) {
          touristApi.getUserList({ deptId: this.form.deptId }).then((res) => {
            const { code, rows } = res;
            if (code === 200) {
              this.userList = rows;
            }
          });
        }
      }
    },
    deep: true
  }
};
</script>

<style lang="less" scoped>
.contract-details {
  background-color: #fff;
  padding: 20px;
  > .title {
    display: flex;
    h1 {
      font-size: 20px;
      color: #000;
      font-weight: 700;
      margin-bottom: 60px;
      cursor: pointer;
    }
  }

  .commission-achievement {
    display: flex;
    justify-content: space-between;
    > div {
      width: 49%;
      border: 1px solid rgb(243, 240, 240);
      padding: 20px;
      border-radius: 15px;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h1 {
          font-size: 14px;
          font-weight: 700;
          color: #222222;
        }
      }
    }
  }
}

// 弹窗样式
/deep/.ant-modal-content {
  padding: 10px 40px;
}
/deep/.ant-modal-header,
/deep/.ant-modal-footer {
  border: none !important;
}
/deep/.ant-modal-header {
  text-align: center;
}

// .contract-details header .more[data-v-6e6c0ad4] {
//   // height: 200px;
// }
</style>
